import "bijou";
import "bijou/smart_form/pickadate";
import "analytics/event_definitions";

$(() => {
  $.bijou.init();
  $.ajaxSetup({
    error(jqXHR, textStatus, errorThrown) {
      if (typeof newrelic !== "undefined" && textStatus !== "abort") {
        const err = new Error(
          `AJAX error with status "${textStatus}" and error message "${errorThrown}". ` +
            `Serialized request: ${JSON.stringify(jqXHR)}`,
        );
        newrelic.noticeError(err);
      }
    },
  });
});
